if (typeof WDN.RangeSlides === "undefined") {
  WDN.RangeSlides = (function () {
    var init, bind, slideOnInput, updateSlideBackground, onPriceRangeInput;
    var updateInputValue;

    var nodes = {
      sliders: document.querySelectorAll("[data-range-slide]"),
      slider_min_price: document.querySelectorAll("[data-range-slide='min_price']"),
      slider_max_price: document.querySelectorAll("[data-range-slide='max_price']"),
      filter_min_price: document.querySelector("[data-filter-range='min_price']"),
      filter_max_price: document.querySelector("[data-filter-range='max_price']"),
      min_price: document.querySelectorAll("input[data-filter-param='filter.v.price.gte']"),
      max_price: document.querySelectorAll("input[data-filter-param='filter.v.price.lte']"),
    };

    updateSlideBackground = function (el) {
      el.style.background = `linear-gradient(to right, #001E3C 0%, #001E3C ${((el.value - el.min) / (el.max - el.min)) * 100}%, #F1F5FB ${
        ((el.value - el.min) / (el.max - el.min)) * 100
      }%, #F1F5FB 100%)`;
    };

    updateInputValue = function (el) {
      var filterKey = el.getAttribute("data-range-slide");
      var inputs = nodes[filterKey];
      if (!inputs) return;
      inputs.forEach(function (input) {
        input.value = el.value;
      });
    };

    onPriceRangeInput = function (el) {
      var filterKey = el.getAttribute("data-range-slide");
      var nodeId = "filter_" + filterKey;
      if (nodes[nodeId]) {
        nodes[nodeId].rangeOnChange();
      }
    };
    var debouncedCallback = WDN.Debounce(onPriceRangeInput, 500);

    slideOnInput = function () {
      updateSlideBackground(this);
      if (this.getAttribute("data-range-slide") !== "") {
        updateInputValue(this);
        debouncedCallback(this);
      }
    };

    var onSliderSet = function (e) {
      var inputs = nodes["slider_" + e.detail.param];
      if (inputs) {
        inputs.forEach(function (input) {
          input.value = parseInt(e.detail.value);
          updateSlideBackground(input);
        });
      }
    };

    bind = function () {
      nodes.sliders.forEach(function (slide) {
        updateSlideBackground(slide);
        slide.addEventListener("input", slideOnInput);
      });

      document.body.addEventListener("range_slider:set", onSliderSet);
    };

    reInit = function () {
      nodes = {
        sliders: document.querySelectorAll("[data-range-slide]"),
        slider_min_price: document.querySelectorAll("[data-range-slide='min_price']"),
        slider_max_price: document.querySelectorAll("[data-range-slide='max_price']"),
        filter_min_price: document.querySelector("[data-filter-range='min_price']"),
        filter_max_price: document.querySelector("[data-filter-range='max_price']"),
        min_price: document.querySelectorAll("input[data-filter-param='filter.v.price.gte']"),
        max_price: document.querySelectorAll("input[data-filter-param='filter.v.price.lte']"),
      };
      init();
    };

    init = function () {
      bind();
      if (nodes.filter_min_price) {
        if (nodes.filter_min_price.updateRangeSliders) {
          nodes.filter_min_price.updateRangeSliders();
        }
      }

      if (nodes.filter_max_price) {
        if (nodes.filter_max_price.updateRangeSliders) {
          nodes.filter_max_price.updateRangeSliders();
        }
      }
    };

    init();

    return {
      reInit,
    };
  })();
}
